import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import DatatableFunc from "../../../../Common/DatatableFunc";
import Http from "../../../../Common/Http";
import IsLogin from "../../../../Common/IsLogin";
import { LoaderComponent } from "../../../../Common/LoaderComponent";
import ReactDropdown from "../../../../Common/ReactDropdown";
import ReceipeDetail from "../ReceipeDetail";
import ReactDataTable from "../../../../Common/ReactDataTable"; // Import ReactDataTable

const Create = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [error, setError] = useState({});
  const [product, setProduct] = useState([]);
  const [rmpm, setRmpm] = useState([]);
  const [factory, setFactory] = useState([]);
  const [department, setDepartment] = useState([]);
  const [lastReceiptNo, setLastReceiptNo] = useState("000001");
  const [list, setList] = useState([]);
  const [listDetail, setListDetail] = useState({});
  const [listDetailId, setListDetailId] = useState({});
  const [custom, setCustom] = useState({});
  const [inputs, setInputs] = useState({
    receipe_type: "fifo",
    requisition_id: id,
  });

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  // ReactDropdown handler for department selection
  const reactDropdownHandler = (field, prop) => (e) => {
    const selectedValue = prop ? e.value[prop] : e.value;
    setInputs((values) => ({
      ...values,
      [field]: selectedValue,
    }));
  };

  // Handle quantity change for dynamic rows
  const handleQuantityChange = (index, value) => {
    const updatedList = [...list];
    updatedList[index].issue_qty = value;
    setList(updatedList);
  };

  const fetchData = async () => {
    try {
      const productWiseStock = await Http.get("/product-wise-stock");
      const processedData = productWiseStock.data.item.map((item) => ({
        ...item,
        itemDisplay: `${item.code} - ${item.name}`,
      }));
      setProduct(processedData);

      const departmentRes = await Http.get("/department");
      setDepartment(departmentRes.data);

      const referenceRes = await Http.get(
        "/last-code-increment-by-one/issues/reference_no/DIS"
      );
      setInputs((values) => ({
        ...values,
        ["reference_no"]: referenceRes.data,
      }));
    } catch (error) {
      console.error("An error occurred while fetching the data:", error);
    }
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);
  // End Default Load

  // Add More List
  // const addMoreList = (id) => {
  //   let exists = false;

  //   list.forEach((item) => {
  //     if (parseInt(item.id) === parseInt(id)) {
  //       alert(
  //         "This Product already in the list! Please choose another product."
  //       );
  //       exists = true;
  //     }
  //   });

  //   if (!exists) {
  //     // Find the product from the product list
  //     const selectedProduct = product.find((p) => p.id === id);
  //     if (selectedProduct) {
  //       const newItem = {
  //         id: selectedProduct.id,
  //         code: selectedProduct.code,
  //         name: selectedProduct.name,
  //         stock_qty: selectedProduct.stock_qty,
  //         issue_qty: 0,
  //         uniqueId: Date.now() + Math.random(), // Unique identifier for React keys
  //       };
  //       setList([...list, newItem]);
  //     }
  //   }
  // };

  const addMoreList = (id) => {
    // Check if the item already exists in the list
    const exists = list.some((item) => parseInt(item.id) === parseInt(id));

    if (exists) {
      alert(
        "This Product is already in the list! Please choose another product."
      );
      return;
    }

    // Find the selected product from the `product` array
    const selectedProduct = product.find((p) => p.id === id);

    if (selectedProduct) {
      // Create a new item with the required fields
      const newItem = {
        uniqueId: Date.now() + Math.random(), // Generate a unique ID
        id: selectedProduct.id,
        code: selectedProduct.code,
        name: selectedProduct.name,
        stock_qty: selectedProduct.stock_qty,
        issue_qty: 0, // Default issue quantity
      };

      // Update the `list` state with the new item
      setList((prevList) => [...prevList, newItem]);
    }
  };

  // Remove List
  // const removeList = (index) => {
  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: "You won't be able to revert this!",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "Yes, delete it!",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       const updatedList = [...list];
  //       updatedList.splice(index, 1);
  //       setList(updatedList);

  //       Swal.fire({
  //         title: "Deleted!",
  //         text: "The item has been removed from the list.",
  //         icon: "success",
  //         timer: 2000,
  //         showConfirmButton: false,
  //       });
  //     }
  //   });
  // };

  const removeList = (index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Create a copy of the list and remove the item at the specified index
        const updatedList = [...list];
        updatedList.splice(index, 1);

        // Debugging: Log the updated list
        console.log("Updated list after removal:", updatedList);

        // Update the state with the new list
        setList(updatedList);

        // Show success message
        Swal.fire({
          title: "Deleted!",
          text: "The item has been removed from the list.",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    });
  };

  const cols = [
    { field: "itemDisplay", header: "Item" },
    { field: "stock_qty", header: "Stock" },
    {
      header: "Action",
      field: (rowData) => (
        <button
          className="btn btn-success btn-sm"
          onClick={() => addMoreList(rowData.id)}
        >
          <i className="fa fa-plus"></i>
        </button>
      ),
    },
  ];

  const formSubmit = () => {
    inputs.list = list;
    inputs.issue_type = "direct";

    Http.post("/issue", inputs)
      .then((res) => {
        navigate("/direct-issue", {
          state: { message: res.data.message, type: "success" },
        });
      })
      .catch(function (e) {
        setError(e.response.data.errors);
      });
  };
  const displayError = (fieldName) => {
    if (error && error[fieldName]) {
      return <div className="text-danger small">{error[fieldName]}</div>;
    }
    return null;
  };

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Create Direct Issue/Out</h5>
        </div>
        <div className="am-pagebody row ms-1">
          <div className="card pd-20 pd-sm-40 col-8">
            <h6 className="card-body-title mg-sm-b-30 text-center">
              Create Direct Issue/Out Form
            </h6>
            <hr></hr>
            <div className="row">
              <div className="col-lg mg-t-10 mg-lg-t-0">
                <label>
                  Reference No <i className="fa fa-star required"></i>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="reference_no"
                  value={inputs.reference_no || ""}
                  onChange={handleChange}
                  placeholder="Input Reference No"
                  data-required
                />

                {displayError("reference_no")}
              </div>
              <div className="col-lg">
                <label>
                  Date <i className="fa fa-star required"></i>
                </label>
                <input
                  type="date"
                  className="form-control"
                  name="date"
                  value={inputs.date || new Date().toISOString().split("T")[0]} // Default to today's date
                  onChange={handleChange}
                  placeholder="Input Date"
                  data-required
                />
                {displayError("date")}
              </div>
              <div className="col-lg">
                <label>
                  Time <i className="fa fa-star required"></i>
                </label>
                <input
                  type="time"
                  className="form-control"
                  name="time"
                  value={
                    inputs.time ||
                    new Date().toLocaleTimeString("en-GB", {
                      hour: "2-digit",
                      minute: "2-digit",
                    })
                  } // Default to current time
                  onChange={handleChange}
                  placeholder="Input Time"
                  data-required
                />
                {displayError("time")}
              </div>
              {/* <div className="col-lg">
                <label>
                  Date <i className="fa fa-star required"></i>
                </label>
                <input
                  type="date"
                  className="form-control"
                  name="date"
                  value={inputs.date || ""}
                  onChange={handleChange}
                  placeholder="Input Date"
                  data-required
                />
                {displayError("date")}
              </div>
              <div className="col-lg">
                <label>
                  Time <i className="fa fa-star required"></i>
                </label>
                <input
                  type="time"
                  className="form-control"
                  name="time"
                  value={inputs.time || ""}
                  onChange={handleChange}
                  placeholder="Input Time"
                  data-required
                />
                {displayError("time")}
              </div> */}
              <div className="col-lg">
                <label>
                  Department <i className="fa fa-star required"></i>
                </label>
                <ReactDropdown
                  options={department}
                  optitle={"name"}
                  onChange={reactDropdownHandler("department_id", "id")}
                />
                {displayError("department_id")}
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-lg">
                <label>Remarks</label>
                <textarea
                  className="form-control"
                  name="remarks"
                  onChange={handleChange}
                  placeholder="Input Remarks"
                >
                  {inputs.time || ""}
                </textarea>
                {displayError("time")}
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-12">
                <div className="card card-solid">
                  <div className="card-header with-border text-center">
                    <h5 className="card-title mb-0">Items in the Recipe</h5>
                  </div>
                  <div
                    className="card-body mt-3 p-0 pt-3"
                    style={{ maxHeight: "500px", overflowY: "auto" }}
                  >
                    <table className="table table-sm table-bordered table-striped align-items-center justify-content-center mb-0">
                      <thead>
                        <tr>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Code
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Product
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Issue Qty
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* {list.map((item, index) => (
                        <tr key={item.uniqueId}>
                          <td>{item.code}</td>
                          <td>{item.name}</td>
                          <td>
                            <input
                              type="number"
                              className="form-control form-control-sm"
                              value={item.issue_qty || ""}
                              onChange={(e) =>
                                handleQuantityChange(index, e.target.value)
                              }
                              placeholder="Enter quantity"
                              min="0"
                              max={item.stock_qty}
                              step="0.01"
                            />
                            <small className="text-muted">
                              Available: {item.stock_qty}
                            </small>
                          </td>
                          <td className="text-center">
                            <button
                              className="btn btn-danger btn-sm"
                              onClick={() => removeList(index)}
                              title="Remove item"
                            >
                              <i className="fa fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                      {list.length === 0 && (
                        <tr>
                          <td colSpan="4" className="text-center text-muted">
                            No items added yet. Click the + button to add
                            products.
                          </td>
                        </tr>
                      )} */}
                        {list.map((item, index) => (
                          <tr key={item.uniqueId}>
                            <td>{item.code}</td>
                            <td>{item.name}</td>
                            <td>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                value={item.issue_qty || ""}
                                onChange={(e) =>
                                  handleQuantityChange(index, e.target.value)
                                }
                                placeholder="Enter quantity"
                                min="0"
                                max={item.stock_qty}
                                step="0.01"
                              />
                              <small className="text-muted">
                                Available: {item.stock_qty}
                              </small>
                            </td>
                            <td className="text-center">
                              <button
                                className="btn btn-danger btn-sm"
                                onClick={() => removeList(index)}
                                title="Remove item"
                              >
                                <i className="fa fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                        {list.length === 0 && (
                          <tr>
                            <td colSpan="4" className="text-center text-muted">
                              No items added yet. Click the + button to add
                              products.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-3">
                <button
                  className="btn btn-primary btn-block mg-b-10"
                  onClick={formSubmit}
                >
                  <i className="fa fa-send mg-r-10"></i> Create
                </button>
              </div>
            </div>
          </div>
          {/* <div
            className="card pd-20 pd-sm-40 col-3 ms-5"
            style={{ backgroundColor: "#ffffffc7" }}
          >
            <h6 className="card-body-title mg-sm-b-30 text-center">Products</h6>
            <hr></hr>
            <div className="row mt-3">
              <table className="table table-sm table-bordered table-striped align-items-center justify-content-center mb-0 datatable">
                <thead>
                  <tr>
                    <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                      Item
                    </th>
                    <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                      Stock
                    </th>
                    <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2"></th>
                  </tr>
                </thead>
                <tbody>
                  {product.map((x, i) => (
                    <tr key={x.id}>
                      <td>
                        {x.code} - {x.name}
                      </td>
                      <td>
                        <p style={{ padding: "7px 0px", marginBottom: "0px" }}>
                          {x.stock_qty ? x.stock_qty : 0}
                        </p>
                      </td>
                      <td className="text-right">
                        <button
                          className="btn btn-success btn-sm"
                          onClick={() => addMoreList(x.id)}
                        >
                          <i className="fa fa-plus"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div> */}
          <div
            className="card pd-20 pd-sm-40 col-3 ms-2"
            style={{ backgroundColor: "#ffffffc7" }}
          >
            <h6 className="card-body-title mg-sm-b-30 text-center">Products</h6>
            <hr></hr>
            <div className="row mt-3">
              <ReactDataTable
                cols={cols}
                receiveData={product} // Pass product as the data source
                isLoading={false} // Set loading state if needed
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Create;
